export default __webpack_public_path__ + "static/online-doctor-consultation-mobile-application-1978ecd76895ce1dc557373adeb85114.jpg";